import React from "react";
import { HashRouter as Router } from "react-router-dom";
import "./dx-styles.scss";
import LoadPanel from "devextreme-react/load-panel";
import { NavigationProvider } from "./contexts/navigation";
import { useAuth } from "./contexts/auth";
import { useScreenSizeClass } from "./utils/media-query";
import Content from "./Content";
import UnauthenticatedContent from "./UnauthenticatedContent";
import "devextreme/dist/css/dx.common.css";
import "./themes/generated/theme.base.css";
import "./themes/generated/theme.additional.css";

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (user) {
    return <Content />;
  }

  return <UnauthenticatedContent />;
}

export default function Main() {
  const screenSizeClass = useScreenSizeClass();
  const { user, loading } = useAuth();

  return (
    <React.Fragment>
      {user && !user.isIframe ? (
        <>
          {loading ? (
            <div style={{ textAlign: "center", fontSize: "14px" }}>
              loading menu...
            </div>
          ) : (
            <new-user-menu
              clientCode={user ? user.clientCode : ""}
              sessionKey={user ? user.sessionKey : ""}
              accountLang='eng'
              user={user ? user.user : "User"}
            ></new-user-menu>
          )}
        </>
      ) : null}

      <Router>
        <NavigationProvider>
          <div
            className={`app ${screenSizeClass}`}
            // style={user && !user.isIframe ? { paddingTop: "px" } : {}}
          >
            <App />
          </div>
        </NavigationProvider>
      </Router>
    </React.Fragment>
  );
}
